import React from 'react'
import styles from './style.module.css'
function LoaderCircle({size}) {
  return (
    <span className={styles.loaderRound} style={{width:`${size}px`,height:`${size}px`,marginLeft:"8px"}}></span>
    )
}

export default LoaderCircle